import { AlertColor } from '@mui/material';
import { INotification } from 'interfaces';

export const makeNotification = (message: string, type: AlertColor): INotification => ({
  message,
  type
});
